import _ from 'lodash';
export const GlobalConst = {
    BASE_URL: `${(!_.isEmpty(process.env.PUBLIC_URL)) ? process.env.PUBLIC_URL : process.env.REACT_APP_BASE_URL}`,
    API_URL: `${process.env.REACT_APP_API_URL}`,
    AUTH_URL: `${process.env.REACT_APP_AUTH_URL}`,
    REDIRECT_URL: `${process.env.REACT_APP_REDIRECT_URL}`,
    CLIENT_ID: `${process.env.REACT_APP_CLIENT_ID}`,
    CLIENT_SECRET: `${process.env.REACT_APP_CLIENT_SECRET}`,
    SUPPORT_EMAIL: "tigers@sec1.io"
}